import React, {Component, useCallback, useEffect} from 'react';
import {Button, Col, Container, Row} from 'reactstrap';
import PageMeta from 'components/PageMeta';
import Video from 'components/Video';
import CheckoutButton from 'components/CheckoutButton';
import Footer from 'components/Elements/Footer';
import logoTrees from 'static/logo/logo-trees-for-future-white.png';
import wlcLogo from 'static/logo/frn-wlc-logo.svg';

import Section, {SectionImage} from 'components/Elements/Section';
import useBeacon from 'utils/useBeacon';
import IconList, {IconListItem} from 'components/Elements/IconList';
import {WlcUpsell} from 'components/SalesCta';

export default function () {
  useBeacon();
  return (
    <div className="page page-nosocial">
      <PageMeta title="WLC Upsell" description="Make FOOD the foundation of YOUR health" />

      <div className="page-content">
        <Section id="section-wlc-header" innerClass="text-white text-center pt-4" color="black">
          <Container>
            <Row className="d-flex justify-content-center mb-4">
              <Col>
                <h3 className="section-heading mb-3">Thank you for your purchase!</h3>
                <p className="m-0">
                  Now, here’s an exclusive offer just for <br className="d-none d-sm-block d-lg-none" />
                  <em>Healthy Brain</em> course participants (like you!)…
                </p>
              </Col>
            </Row>

            <Row className="d-flex justify-content-center">
              <Col lg="10" className="video-col px-0 px-sm-3">
                <Video url="https://www.youtube.com/watch?v=kmmdArSfciA" label="HBC - UHC Upsell" />
              </Col>
            </Row>
          </Container>
        </Section>

        <Section id="section-wlc-info" color="white">
          <Container>
            <Row>
              <Col>
                <h5 className="section-only-heading text-center">
                  An online membership community to help you sustain <br className="d-none d-xl-block" />
                  and optimize for LASTING RESULTS. Introducing:
                </h5>
              </Col>
            </Row>
            <Row className="d-flex justify-content-center">
              <Col md="10" lg="8" xl="6">
                <img src={wlcLogo} />
              </Col>
            </Row>
            <Row>
              <Col className="text-center">
                <p>
                  If you want to keep on <strong>deepening and LOVING your brain healthy lifestyle…</strong> this is for
                  you
                </p>
                <p>
                  <em>This offer won’t be available to you again after you close this page.</em>
                </p>
              </Col>
            </Row>
          </Container>
        </Section>

        <SectionImage
          id="section-wlc-ignite"
          imgPosition="right"
          color="light-gray"
          imgUrl={require('static/backgrounds/woman-laughing-square.jpg')}
        >
          <h3 className="section-heading">
            Healthy Brain will ignite a fire in you. <br className="d-none d-sm-block d-md-none d-xl-block" />A fire
            that lights the way to a healthier, leaner, more clear-minded future.
          </h3>
          <h4 className="text-400 mt-0">
            WHOLE Life Club is the perfect <br className="d-none d-lg-block d-xl-none" />
            next step!
          </h4>
          <p>
            Imagine being able to steadily improve your brain (and overall) <br className="d-none d-xl-block" />
            healthy living lifestyle, to enjoy a delightful flow of mouthwatering and nourishing new recipes, and to
            share your transformational journey with friends and allies — not just for 6 weeks, but for your WHOLE Life.
          </p>
          <p>
            <strong>
              WHOLE Life club will provide a sustained wind at your back, helping you to ensure that the breakthroughs
              you experience in Healthy Brain become the health-boosting path of a lifetime.
            </strong>
          </p>
          <p>
            When you join <u>right now,</u> you’ll{' '}
            <strong>
              get a special opportunity ONLY <br className="d-none d-xl-block" />
              for <em>Healthy Brain</em> course participants,
            </strong>{' '}
            and ONLY available <br className="d-none d-xl-block" />
            from this page:
          </p>
          <h5 className="mt-0">Get 3 months of WHOLE Life Club for FREE!</h5>
          <p>
            After three months, you’ll be auto-billed $19/month (a 33% discount <br className="d-none d-xl-block" />
            off the regular $29/month rate). And if you don’t LOVE it, you can cancel any time during the three-month
            trial, and you’ll never be charged a penny.
          </p>
        </SectionImage>

        <Section id="section-wlc-offer" innerClass="text-white text-center" color="gradient-indigo-purple-right">
          <Container>
            <Row>
              <Col>
                <WlcUpsell
                  offerBoxBackground="offer-box-dark"
                  offerBoxBorder="offer-box-borderless"
                  offerBoxPadding="px-3 px-sm-4 px-md-5"
                  noTrees
                />
              </Col>
            </Row>
          </Container>
        </Section>

        <div className="d-none d-lg-block">
          <Section id="section-wlc-join-a" color="white">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-only-heading text-center">Here’s What You’ll Get When You Join...</h2>
                </Col>
              </Row>
            </Container>
          </Section>
        </div>

        <SectionImage
          id="section-wlc-join-b"
          imgPosition="right"
          color="white"
          imgUrl={require('static/backgrounds/couple-computer-square.jpg')}
        >
          <h2 className="section-heading d-lg-none">
            Here’s What You’ll Get When <br className="d-none d-sm-block d-lg-none" />
            You Join...
          </h2>
          <h3 className="section-heading">Wisdom</h3>
          <p>
            <em>“Knowledge you can use, from experts you can trust.”</em>
          </p>
          <IconList>
            <IconListItem>
              <strong>Monthly online Action Hour events</strong> with top health revolutionaries (including
              opportunities to share your opinions and <em>ask YOUR questions</em>). Plus, downloadable MP3s and
              transcripts.
            </IconListItem>
            <IconListItem>
              <strong>Weekly action videos and Action Checklists,</strong> so you can keep making easy and steady
              progress towards your health goals.
            </IconListItem>
          </IconList>
        </SectionImage>

        <SectionImage
          id="section-wlc-join-c"
          imgPosition="left"
          color="light-gray"
          imgUrl={require('static/backgrounds/food-square.jpg')}
        >
          <h3 className="section-heading">Recipes</h3>
          <p>
            <em>“Love foods that love you back.”</em>
          </p>
          <IconList>
            <IconListItem>
              <strong>A new set of delicious, whole-foods, plant-powered recipes every week</strong> that are
              nutritious, affordable, easy-to-prepare, and taste amazing.
            </IconListItem>
            <IconListItem>
              Tips and tricks to help you <strong>make healthy eating simple and efficient.</strong>
            </IconListItem>
          </IconList>
        </SectionImage>

        <SectionImage
          id="section-wlc-join-d"
          imgPosition="right"
          color="white"
          imgUrl={require('static/backgrounds/super-square.jpg')}
        >
          <h3 className="section-heading">Community</h3>
          <p>
            <em>“Be a part of the WHOLE.”</em>
          </p>
          <IconList>
            <IconListItem>
              <strong>Join with health-minded people</strong> to share insights, receive guidance, spread the food
              revolution, build connections, and achieve your lifestyle goals.
            </IconListItem>
            <IconListItem>
              <strong>Use the moderated forum</strong> (which is NOT on Facebook) to ask your questions and get real,
              trustworthy answers. You can start and join in conversations on topics that matter to you, and connect
              with peers who share your values and concerns.
            </IconListItem>
          </IconList>
        </SectionImage>

        <Section
          id="section-wlc-offer"
          className="section-angle-last"
          color="gradient-indigo-purple-right"
          angle="none"
        >
          <Container>
            <Row>
              <Col>
                <WlcUpsell />
              </Col>
            </Row>
          </Container>
        </Section>
      </div>

      <Footer />
    </div>
  );
}
